import { Chip, FormControl, InputLabel, MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { INVOICE_STATUSES, InvoiceStatus } from '@sr/dto';
import { useSearchParams } from 'react-router-dom';
import { IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const INPUT_SLICE_INDEX = 3;

const InvoiceStatusValue = (selectedItems: string[]) => {
  if (selectedItems.length <= INPUT_SLICE_INDEX) {
    return selectedItems.map((item: string) => (
      <Chip
        sx={{ mr: 0.5, p: 0 }}
        size={'small'}
        key={item}
        label={INVOICE_STATUSES[Number(item) as InvoiceStatus]}
      />),
    );
  }

  return (
    <>
      {
        selectedItems
          .sort((a, b) => a.length - b.length)
          .slice(0, INPUT_SLICE_INDEX)
          .map((item: string) => (
            <Chip sx={{ mr: 0.5 }} size={'small'} key={item} label={INVOICE_STATUSES[Number(item) as InvoiceStatus]} />),
          )
      }
      <Chip size={'small'} key={'three-dots-chip'} label={'...'} />
    </>
  );
};

type Props = { 
  queryParamName: string;
  multiple?: boolean; 
 }

export const InvoiceStatusUrlParamsFilter = ({ queryParamName, multiple=true}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const { target: { value } } = event;

    setSearchParams(prev => {
      if (value.length > 0) {
        prev.set(queryParamName, `${value}`);
      } else {
        prev.delete(queryParamName);
      }
      return prev;
    }, { replace: true });
  };

  const statuses: string[] = searchParams?.get(queryParamName)?.split(',') ?? [];

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="invoice-status-select-label" sx={{ backgroundColor: 'white', px: 1 }}>
          Статус счета
        </InputLabel>
        <Select
          labelId="invoice-status-select-label"
          value={statuses}
          renderValue={InvoiceStatusValue}
          onChange={handleChange}
          multiple={multiple}
          variant={'outlined'}
          endAdornment={
            statuses.length > 0 && (
              <IconButton sx = {{ mr: 1.5, height: 24, width:24 }}
                onClick={() => {
                  setSearchParams((prev) => {
                    prev.delete(queryParamName);
                    return prev;
                  }, { replace: true });
                }}
              >
                <ClearIcon/>
              </IconButton>
            )
          }
        >
          {Object.keys(INVOICE_STATUSES).map(key =>
            <MenuItem key={key} value={key}>
              {INVOICE_STATUSES[Number(key) as InvoiceStatus]}
            </MenuItem>,
          )
          }
        </Select>
      </FormControl>
    </>);
};
